import { inject, Injectable, signal } from '@angular/core';

import type { ConversationStarter } from '@core/tellent-assistant-types';

import { TellentAssistantService } from './tellent-assistant.service';

@Injectable({ providedIn: 'root' })
export class TellentAssistantControlService {
  private readonly assistant = inject(TellentAssistantService);

  public readonly open = signal<boolean>(false);

  public toggle(): void {
    this.open.update(value => !value);
  }

  public close(): void {
    this.open.set(false);
  }

  public openWith(starter: ConversationStarter): void {
    this.open.set(true);
    this.assistant.newThread();
    this.assistant.sendStarter(starter);
  }
}
